import Config from "config";

import { ApiService } from "Services/api";
import Profile from "Services/profile";
import User from "Services/user";

const STORAGE_KEYS = {
  STRINGS_LANGS: "strings_langs",
  LANG_LAST_UPDATE: "strings_langs_last-update",
  DEFAULT_LANG: "default_lang",
};

export const LANG_EN_KEY = "en";
export const LANG_RU_KEY = "ru";
export const LANG_PT_KEY = "pt_br";
export const LANG_ES_KEY = "es";

export const AVAILABLE_LANGUAGES = [
  {
    iso: LANG_EN_KEY,
    title: "English",
  },
  {
    iso: LANG_RU_KEY,
    title: "Русский",
  },
  {
    iso: LANG_PT_KEY,
    title: "Portuguese",
  },
  {
    iso: LANG_ES_KEY,
    title: "Spanish",
  },
];

class I18nService {
  async getStrings(language) {
    const prefix = Config.role === "publisher" ? "notix_pub" : "pub";
    const langs = await window.localStorage.getItem(STORAGE_KEYS.STRINGS_LANGS);
    const defaultLanguage = await this.getDefaultLanguage();
    if (defaultLanguage === language && langs !== null) {
      const responseLastUpdate = await ApiService.get(
        `/public/i18n/${prefix}/last_update/?lang=${language}`
      );
      const serverLastUpdate = responseLastUpdate.last_update;
      const currentLastUpdate = JSON.parse(
        await window.localStorage.getItem(STORAGE_KEYS.LANG_LAST_UPDATE)
      );
      if (currentLastUpdate === serverLastUpdate) {
        return;
      }
    }

    const newLangsResponse = await ApiService.get(
      `/public/i18n/${prefix}/lang/?lang=${language}`
    );
    if (newLangsResponse === null) {
      console.error("😔 No translation, please, refresh page!");

      return;
    }

    await window.localStorage.setItem(
      STORAGE_KEYS.LANG_LAST_UPDATE,
      JSON.stringify(newLangsResponse.last_update)
    );

    await window.localStorage.setItem(
      STORAGE_KEYS.STRINGS_LANGS,
      JSON.stringify(newLangsResponse.translations)
    );
  }

  getDefaultLanguage() {
    const [firstLanguage] = AVAILABLE_LANGUAGES;
    return (
      JSON.parse(window.localStorage.getItem(STORAGE_KEYS.DEFAULT_LANG)) ||
      firstLanguage.iso
    );
  }

  setDefaultLanguage(language) {
    if (User.isAuthenticated() && !User.isReadOnly()) {
      return Profile.setLanguage(language).finally(() => {
        return window.localStorage.setItem(
          STORAGE_KEYS.DEFAULT_LANG,
          JSON.stringify(language)
        );
      });
    }

    return Promise.resolve().then(() => {
      return window.localStorage.setItem(
        STORAGE_KEYS.DEFAULT_LANG,
        JSON.stringify(language)
      );
    });
  }

  getLocale(language) {
    switch (language) {
      case LANG_RU_KEY:
        return "ru-RU";
      case "cn":
        return "zh-Hans-CN";
      case "fr":
        return "fr";
      case "de":
        return "de";
      case "it":
        return "it";
      case "es":
        return "es";
      case "tr":
        return "tr";
      case LANG_EN_KEY:
      default:
        return "en-US";
    }
  }

  getLanguagesForClient() {
    return AVAILABLE_LANGUAGES.map((language) => {
      return {
        title: language.title,
      };
    });
  }

  getStringByKey(key) {
    const currentLanguage = JSON.parse(
      window.localStorage.getItem(STORAGE_KEYS.STRINGS_LANGS)
    );

    const foundTranslate = currentLanguage?.find((item) => item.key === key);

    return foundTranslate ? foundTranslate.translation : key;
  }

  getLanguageTitle(iso) {
    return AVAILABLE_LANGUAGES.find((lang) => lang.iso === iso).title;
  }
}

const i18nServiceInstance = new I18nService();

export default i18nServiceInstance;